<template>
  <div class="row">
    <div class="col-6 col-lg-5 owner-card__label">{{ label }}</div>
    <div class="col-1 col-lg-1 owner-card__value">{{ value }}</div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/variables';
.owner-card {
  &__label {
    padding: 0 0 0 20px;
  }

  &__value {
    color: $color-primary-text;
    font-weight: 600;
  }
}
</style>